import { useGateValue } from '@statsig/react-bindings'
import type fallbackFeatureGates from '../../__generated__/default_feature_gates'

type FeatureGateName = keyof typeof fallbackFeatureGates

export const useFeatureGate = (name: FeatureGateName): boolean => {
  return useGateValue(name)
}
